module.exports = __webpack_public_path__ + "static/media/ico-interesting.827656d5.svg";